<template  >
  <div>
    <v-dialog v-model="dialog" width="450" persistent :fullscreen="x_mobile">
      <v-card class="pb-2">
        <v-form ref="form" @submit.prevent="save">
          <v-card-title class="form-dialog-title" primary-title>
            นำส่งรายงาน
            <v-spacer></v-spacer>
            <v-btn icon class="float-right" @click="close">
              <v-icon>mdi-window-close</v-icon>
            </v-btn>
          </v-card-title>
          <!-- <pre>{{select_num_report}}</pre> -->

          <v-card-text class="py-0">
            <v-row align="center" justify="center" class="px-3">
              <v-col cols="12" class="py-0">
                รายงาน :
                <v-select
                  v-model="select_num_report"
                  :items="select_month"
                  item-text="text"
                  item-value="num"
                  dense
                  single-line
                  label="เลือก"
                  outlined
                  :rules="rule_empty"
                ></v-select>
              </v-col>

              <v-col cols="12" class="py-0">
                ถึง :
                <v-autocomplete
                  :readonly="mode"
                  :disabled="mode"
                  v-model="report_mail"
                  :items="all_email_data"
                  outlined
                  chips
                  single-line
                  item-text="email"
                  color="blue-grey lighten-2"
                  label="อีเมล"
                  multiple
                  :rules="rule_empty"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :close="!mode"
                      @click="data.select"
                      @click:close="mode?'':remove(data.item)"
                    >
                      <!-- <v-avatar left>
                        <v-img :src="data.item.avatar"></v-img>
                      </v-avatar>-->
                      {{ data.item.email }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <span>ไม่มีข้อมูล</span>
                    </template>
                    <template v-else>
                      <!-- <pre>{{all_email_data}}</pre> -->
                      <v-list-item-avatar
                        color="#e6e6e6"
                        class="mr-3 my-0 font-kanit-light"
                        size="35"
                      >{{data.item.email[0]}}</v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-subtitle v-html="data.item.email"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-6">
            <v-spacer></v-spacer>
            <v-btn :loading="btn_loading" color="button" dark type="submit" small>ยืนยัน</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      header_token: { headers: { token: this.$session.get("token") } },
      dialog: false,
      profile: {},
      mode: false,
      report_mail: [],
      all_email_data: [],
      select_num_report: "",
      btn_loading: false,
      rule_empty: [(v) => !!v || "กรุณาเลือกข้อมูล"],
      // rule_empty_email: [(v) => v == [] || "กรุณาเลือกข้อมูล"],
    };
  },
  created() {
    this.getData();
  },
  computed: {
    x_mobile() {
      if (this.$vuetify.breakpoint.width < 375) {
        return true;
      } else {
        return false;
      }
    },
    select_month() {
      let date_now = new Date().toISOString().substr(0, 10);
      let [year, month, day] = date_now.split("-");
      year = parseInt(year) + 543;
      let show_select_month = [];
      let show_select_month_and_num = [];
      const all_month = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];
      month = month - 1;
      let string_month = "";
      if (parseInt(month - 1) > 1) {
        for (
          let index = parseInt(month - 3);
          index < parseInt(month);
          index++
        ) {
          string_month = all_month[index] + " " + String(year);
          show_select_month.push(string_month);
        }
      } else if (parseInt(month - 1) <= 1) {
        if (parseInt(month - 1) == 1) {
          string_month = all_month[11] + " " + String(year - 1);
          show_select_month.push(string_month);
          for (let index = 0; index < 2; index++) {
            string_month = all_month[index] + " " + String(year);
            show_select_month.push(string_month);
          }
        } else {
          for (let index = 10; index < 12; index++) {
            string_month = all_month[index] + " " + String(year - 1);
            show_select_month.push(string_month);
          }
          string_month = all_month[parseInt(month - 1)] + " " + String(year);
          show_select_month.push(string_month);
        }
      }
      show_select_month.forEach((element, index) => {
        show_select_month_and_num.push({
          num: 3 - index,
          text: element,
        });
      });

      return show_select_month_and_num;
    },
  },
  methods: {
    getData() {
      let all_email = [];
      this.all_email_data = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/rate/email", this.header_token)
        .then((response) => {
          all_email = response.data.result;
          if (
            response.data.result &&
            response.data.status == "OK" &&
            response.data.status != "FAIL"
          ) {
            this.all_email_data = all_email;
          }
          // console.log(this.all_members);
        });
    },
    openDialogReportRateMail(item) {
      this.getData();
      // console.log(this.$session.getAll());
      // console.log(item);
      this.report_mail = [];
      if (item) {
        this.report_mail.push(item.email);
        this.mode = true;
      } else {
        this.report_mail = [];
        this.mode = false;
      }
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 50);
      this.select_num_report = "";
      this.dialog = true;
    },
    remove(item) {
      const index = this.report_mail.indexOf(item.email);
      if (index >= 0) this.report_mail.splice(index, 1);
    },
    save() {
      if (
        this.$refs.form.validate() &&
        this.select_num_report != "" &&
        this.report_mail != ""
      ) {
        this.btn_loading = true;
        // let email_list = [];
        // this.report_mail.forEach((element) => {
        //   console.log(element);
        //   email_list.push(element);
        // });
        // console.log(email_list);
        let data = {
          back: this.select_num_report,
          to: this.report_mail,
        };
        // console.log(data);
        this.axios
          .post(
            process.env.VUE_APP_API + "/api/v1/rate/report",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data.result);
            if (
              response.data.status == "OK" &&
              response.data.status != "FAIL"
            ) {
              this.$swal.fire({
                icon: "success",
                width: 500,
                title: response.data.message,
                text: " ดำเนินการบันทึกข้อมูลเรียบร้อยแล้ว",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
              this.close();
              this.$emit("report_rate_mail", "add");
            } else {
              this.$swal.fire({
                icon: "error",
                width: 500,
                title: response.data.message,
                text: "กรุณาตรวจสอบข้อมูลของท่าน",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
              this.close();
            }
            // console.log(this.all_members);
          })
          .catch((err) => {
            this.$swal.fire({
              icon: "error",
              width: 500,
              title: "เกิดข้อผิดพลาด",
              showConfirmButton: false,
              timer: 2000,
              showCloseButton: true,
            });
          });
      } else {
        this.$swal.fire({
          icon: "warning",
          width: 500,
          title: "กรุณาตรวจสอบข้อมูล",
          showConfirmButton: false,
          timer: 2000,
          showCloseButton: true,
        });
      }
    },
    close() {
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 50);
      this.report_mail = [];
      this.mode = false;
      this.select_num_report = "";
      this.dialog = false;
      this.btn_loading = false;
    },
  },
};
</script>
